import React from 'react';
import Layout from '../components/Layout';

const BASE = "/images/";

export default function PrinterSetup() {
  return (
    <Layout bannerTitle="How To Setup Your Device">
      <div className="main-content" id="setup-section">

        {/* Zig-zag 1 */}
        <div className="zigzag-section">
          <div className="zigzag-text">
            <h2>Why is My Printer not Connected to Wi-Fi?</h2>
            <p>
              Here are some steps that you can check to connect your Printer to the internet or your home
              Wifi connection. But if the problem doesn't get resolved even after following the given steps,
              you can take our support and leave us a message to resolve your issue with our experts.
            </p>
            <ul>
              <li>If your wireless printer setup fails to connect with your internet, check for network issues and review setup requirements.</li>
              <li>Move your Printer and device closer to the router and check the signal quality.</li>
              <li>If the printer is in sleep mode, touch the touchscreen or press the Power button to wake it up.</li>
              <li>Restore the wireless connection or restart your Printer to identify and fix network issues.</li>
              <li>Check the wireless setting and make sure that the signal is turned on.</li>
            </ul>
          </div>
          <div className="zigzag-media">
            <img src={`${BASE}laser-printer.jpg`} alt="Laser printer" />
          </div>
        </div>

        {/* Zig-zag 2 — reversed */}
        <div className="zigzag-section reverse">
          <div className="zigzag-text">
            <h2>How Can Smart Device Assistant Help You?</h2>
            <p>
              At Smart Device Assistant, we have an experienced team who can guide you on printer
              troubleshooting and provide you with instant support to fix common challenges you face
              while connecting your printer with an internet connection, laptop, computer, or mobile device.
            </p>
            <p>
              If you want to resolve your query within a few minutes and want professional help for free,
              you can send us a message to start a conversation with our experts.
            </p>
            <p>
              Moreover, if you have just bought a brand new Printer from the market, regardless of its
              type and size, we ensure to address all your problems without any hassle.
            </p>
          </div>
          <div className="zigzag-media">
            <img src={`${BASE}printer.jpg`} alt="Printer assistance" />
          </div>
        </div>

        {/* Zig-zag 3 */}
        <div className="zigzag-section">
          <div className="zigzag-text">
            <h2>Why Won't My Printer Connect to Wi-Fi During Setup?</h2>
            <p>Below are some reasons why your printer may not connect to Wi-Fi during setup, and DIY tips to troubleshoot:</p>
            <ul>
              {[
                'Make sure your printer is on.',
                'Connect your printer to your computer/laptop or other devices.',
                'Check the toner and paper of your printer.',
                'Check for error messages or warning lights on the printer.',
                'Confirm that you are using the right network.',
                'If you recently updated security software or OS, reinstall updated drivers.',
                'Check router settings and restart all your devices.',
                'Set your printer as a default printer.',
                'Update router firmware and disable VPN Connections.',
              ].map((item, i) => <li key={i}>{item}</li>)}
            </ul>
          </div>
          <div className="zigzag-media">
            <img src={`${BASE}queryimg.png`} alt="Query assistance" />
          </div>
        </div>

        {/* Query card */}
        <div className="query-card" style={{ marginTop: '1rem' }}>
          <h2>What Type of Query Do You Have?</h2>
          <ul className="query-list">
            {[
              'How to set up a printer?',
              'How to connect a printer to wifi?',
              'How to fix the printer sleep mode issue?',
              'How to set up printers on windows?',
              'How to set up printers on mac?',
              'How do I install a printer?',
              'What are the steps for setting up a wireless printer?',
              'How to connect an HP printer to new wifi?',
              'What are my printer wifi settings?',
            ].map((q, i) => (
              <li key={i}>{q}</li>
            ))}
          </ul>
          <p style={{ marginTop: '1rem', fontSize: '0.95rem' }}>
            If you want to know the answer to any of the above questions, connect with us to get professional
            assistance. We ensure to help you faster and easier to resolve your issue.
          </p>
        </div>

      </div>
    </Layout>
  );
}
